export const PAGE_KEY = 'COMMUNITY_INTERNAL_COMMS_PAGE';
